import * as React from "react";
const SVGComponent = ({ color, ...props }) => (
  <svg
    width={23}
    height={28}
    viewBox="0 0 23 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.5704 11.9758L7.87704 23.569C6.28131 26.3329 2.82635 24.3382 4.42207 21.5743L11.1154 9.98108C8.57086 6.05512 10.7341 1.77642 15.1878 1.68626L14.0353 3.6825C11.8633 7.44452 16.4699 10.1041 18.6419 6.34212L19.7944 4.34588C22.1499 8.77683 19.3192 12.2612 14.5703 11.9758L14.5704 11.9758ZM8.22073 20.4915L7.24554 22.1806C6.66929 23.1787 5.36413 22.4251 5.94039 21.427L6.91557 19.738C7.49183 18.7399 8.79698 19.4934 8.22073 20.4915Z"
      fill={color}
    />
  </svg>
);
export default SVGComponent;
